// usePageContent — fetches editable CMS blocks for a given page.
// Returns a `get(blockKey, fallback)` helper so components can render
// server-side defaults while the request is in-flight.

import axios from "axios";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// In-memory cache so page navigation doesn't refetch.
const cache = new Map();

export function usePageContent(page) {
    const [blocks, setBlocks] = useState(() => cache.get(page) || {});
    const [loaded, setLoaded] = useState(() => cache.has(page));

    useEffect(() => {
        let cancelled = false;
        if (cache.has(page)) {
            setBlocks(cache.get(page));
            setLoaded(true);
            return () => {};
        }
        axios
            .get(`${API}/page-content/${page}`)
            .then((res) => {
                if (cancelled) return;
                cache.set(page, res.data || {});
                setBlocks(res.data || {});
                setLoaded(true);
            })
            .catch(() => {
                if (!cancelled) setLoaded(true);
            });
        return () => {
            cancelled = true;
        };
    }, [page]);

    const get = (key, fallback = "") => (blocks && blocks[key]) || fallback;
    return { get, loaded, blocks };
}

// Invalidate cache when an admin updates content.
export function invalidatePageContent(page) {
    if (page) cache.delete(page);
    else cache.clear();
}
